"use client";

/**
 * Rail default home state with pending changes summary and actions.
 *
 * Extracted from `compass-intake.jsx:754-772` (`.cs-railhome`, `.rh-*`).
 */

export interface RailHomeProps {
  /** Handler invoked when the user clicks "Revise report". */
  onReviseReport?: () => void;
  /** Handler invoked when the user clicks "Ask a question about this report". */
  onAskQuestion?: () => void;
}

export function RailHome({ onReviseReport, onAskQuestion }: RailHomeProps) {
  return (
    <div className="flex flex-col gap-[22px] p-[18px] box-border w-full">
      {onAskQuestion && (
        <button
          type="button"
          className={[
            "flex items-center w-full text-left",
            "text-[13px] text-(--fg-secondary)",
            "bg-(--bg-canvas) border border-(--border-subtle)",
            "rounded-(--radius-sm) px-[13px] py-[11px]",
            "cursor-pointer transition-colors duration-300",
            "font-[family-name:var(--font-body)]",
            "hover:bg-(--bg-sky) hover:border-(--border-default)",
          ].join(" ")}
          onClick={onAskQuestion}
        >
          Ask a question about this report
        </button>
      )}

      {/* Report section */}
      <div className="flex flex-col gap-[10px]">
        <div className="text-[10.5px] tracking-[.09em] uppercase text-(--fg-muted) font-semibold">
          Report
        </div>
        <button
          type="button"
          className={[
            "flex items-center justify-center gap-2 w-full",
            "text-[13px] font-medium text-(--fg-primary)",
            "bg-(--bg-white) border border-(--border-default)",
            "rounded-(--radius-sm) px-[13px] py-[10px]",
            "cursor-pointer transition-all duration-300",
            "font-[family-name:var(--font-body)]",
            "hover:bg-(--bg-sky) hover:border-(--border-strong)",
          ].join(" ")}
          onClick={onReviseReport}
        >
          Revise report
        </button>
      </div>

      {/* Hint */}
      <div className="text-[12px] leading-[1.5] text-(--fg-muted) pt-[18px] border-t border-(--border-subtle)">
        Select a source to open it here.
      </div>
    </div>
  );
}
